/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} businessNameGeneratorGeneratorFinishedParams
* @property {string} additionalInfo - json: { field_name: “Name”, field_value: “value”}
* @property {string} brandId - null
* @property {string} errorType - error if failed
* @property {boolean} isSuccess - true/false
* @property {string} logoSessionId - null
* @property {string} origin - Landing Page / One App etc.
* @property {string} taskId - Task ID
**/
/**
 * Name: BusinessNameGenerator.Generator.Finished. Evid: 5003.
 * Event description: On Generate names task finish.

 * additionalInfo - Type: string. Desc: json: { field_name: “Name”, field_value: “value”}
 *
 * brandId - Type: string.
 *
 * errorType - Type: string. Desc: error if failed
 *
 * isSuccess - Type: bool. Desc: true/false
 *
 * logoSessionId - Type: string.
 *
 * origin - Type: string. Desc: Landing Page / One App etc.
 *
 * taskId - Type: string. Desc: Task ID
 * @param {businessNameGeneratorGeneratorFinishedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var businessNameGeneratorGeneratorFinished = function (params) {
    return { evid: 5003, src: 88, endpoint: 'bng', params: params };
};
/**
* @typedef {Object} businessNameGeneratorFinalActionClickParams
* @property {string} actionName - view_brand / edit_logo / find_domain / get_website
* @property {string} additionalInfo - json: { field_name: “Name”, field_value: “value”}
* @property {string} brandId - null
* @property {GUID} logoId - Logo ID
* @property {string} logoSessionId - null
* @property {string} origin - Landing Page / One app / etc.
* @property {string} pageName - Name
**/
/**
 * Name: BusinessNameGenerator.FinalAction.click. Evid: 5004.
 * Event description: the same as button click but just to split final actions.

 * actionName - Type: string. Desc: view_brand / edit_logo / find_domain / get_website
 *
 * additionalInfo - Type: string. Desc: json: { field_name: “Name”, field_value: “value”}
 *
 * brandId - Type: string.
 *
 * logoId - Type: guid. Desc: Logo ID
 *
 * logoSessionId - Type: string.
 *
 * origin - Type: string. Desc: Landing Page / One app / etc.
 *
 * pageName - Type: string. Desc: Name
 * @param {businessNameGeneratorFinalActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var businessNameGeneratorFinalActionClick = function (params) {
    return { evid: 5004, src: 88, endpoint: 'bng', params: params };
};
/**
* @typedef {Object} businessNameGeneratorPageOpenParams
* @property {string} brandId - null
* @property {string} industry - industry submitted in LP
* @property {string} logoSessionId - null
* @property {string} origin - Landing Page / One App etc.
* @property {string} pageName - name
**/
/**
 * Name: BusinessNameGenerator.PageOpen. Evid: 5000.
 * Event description: on Page Open.

 * brandId - Type: string.
 *
 * industry - Type: string. Desc: industry submitted in LP
 *
 * logoSessionId - Type: string.
 *
 * origin - Type: string. Desc: Landing Page / One App etc.
 *
 * pageName - Type: string. Desc: name
 * @param {businessNameGeneratorPageOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var businessNameGeneratorPageOpen = function (params) {
    return { evid: 5000, src: 88, endpoint: 'bng', params: params };
};
/**
* @typedef {Object} businessNameGeneratorButtonClickParams
* @property {string} additionalInfo - json: { field_name: “Name”, field_value: “value”}
* @property {string} brandId - null
* @property {string} buttonName - Start / Next / Cancel / Skip etc.
* @property {string} logoSessionId - null
* @property {string} origin - Landing Page / One App etc.
* @property {string} pageName - Name
**/
/**
 * Name: BusinessNameGenerator.Button.click. Evid: 5001.
 * Event description: on Button click.

 * additionalInfo - Type: string. Desc: json: { field_name: “Name”, field_value: “value”}
 *
 * brandId - Type: string.
 *
 * buttonName - Type: string. Desc: Start / Next / Cancel / Skip etc.
 *
 * logoSessionId - Type: string.
 *
 * origin - Type: string. Desc: Landing Page / One App etc.
 *
 * pageName - Type: string. Desc: Name
 * @param {businessNameGeneratorButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var businessNameGeneratorButtonClick = function (params) {
    return { evid: 5001, src: 88, endpoint: 'bng', params: params };
};
/**
* @typedef {Object} businessNameGeneratorGeneratorStartedParams
* @property {string} additionalInfo - json: { field_name: “Name”, field_value: “value”}
* @property {string} brandId - null
* @property {string} logoSessionId - null
* @property {string} origin - Landing Page / One App etc.
* @property {string} taskId - Task ID
**/
/**
 * Name: BusinessNameGenerator.Generator.Started. Evid: 5002.
 * Event description: On Generate names task start.

 * additionalInfo - Type: string. Desc: json: { field_name: “Name”, field_value: “value”}
 *
 * brandId - Type: string.
 *
 * logoSessionId - Type: string.
 *
 * origin - Type: string. Desc: Landing Page / One App etc.
 *
 * taskId - Type: string. Desc: Task ID
 * @param {businessNameGeneratorGeneratorStartedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var businessNameGeneratorGeneratorStarted = function (params) {
    return { evid: 5002, src: 88, endpoint: 'bng', params: params };
};
//# sourceMappingURL=index.js.map